import { postMetaConverter } from '@shared/services/meta';
import { postPlatesForm } from '@shared/services/services';
import _ from 'lodash';

export function submitPlate(
  plate_link,
  plateID,
  pageConfiguration,
  plate,
  user,
  setTitleModal,
  setSubtitleModal,
  setShowModal,
  setSubsidiary
) {
  return async (values, { resetForm }) => {
    const data = {
      ...values,
      plate_link,
      plates: parseInt(plateID),
      sites: pageConfiguration.id,
    };

    if (data?.minors_ages?.length > 0) {
      data.minors_ages = _.map(_.groupBy(data.minors_ages, 'age'), x => {
        return { age: x[0].age, quantity: x.length };
      });
    }
    try {
      await postPlatesForm(data).then(() => {
        const value = {
          fecha_desde: data?.date_from,
          fecha_hasta: data?.date_to,
          pasajero_nombre: data?.first_name,
          pasajero_apellido: data?.last_name,
          pasajero_email: data?.email,
          pasajero_telefono: data?.whatsapp,
          pasajeros_cantidad: data.adults_quantity + data.minors_quantity,
          precio: plate?.amount,
          titulo: plate?.title,
          destino: plate?.categories?.name,
        };

        window.dataLayer.push({
          event: 'formularioPlaca',
          eventProps: {
            category: 'placas',
            action: 'submit',
            label: 'enviar',
            value,
          },
        });
        postMetaConverter(
          {
            event_name: 'formularioPlaca',
            custom_data: {
              category: 'placas',
              action: 'submit',
              label: 'enviar',
              ...value,
            },
          },
          user
        );
        setTitleModal('Muchas gracias!');
        setSubtitleModal('Nos pondremos en contacto con usted a la brevedad.');
        setShowModal(true);
      });
    } catch (error) {
      setTitleModal('Ha ocurrido un error');

      setShowModal(true);
      return;
    } finally {
      resetForm();
      setSubsidiary({});
    }
  };
}
